import React from 'react';

const sizes = {
  xs: 'h-4 w-4 border-2',
  sm: 'h-5 w-5 border-2',
  md: 'h-8 w-8 border-[3px]',
  lg: 'h-12 w-12 border-4',
  xl: 'h-16 w-16 border-4',
};

/**
 * Centralised loading spinner — replaces the 4+ hand-rolled
 * `animate-spin border-... border-t-transparent` variants.
 */
export function Spinner({ size = 'md', label, className = '', ...props }) {
  const sizeClasses = sizes[size] || sizes.md;
  return (
    <span role="status" className={`inline-flex items-center justify-center ${className}`} {...props}>
      <span
        className={`animate-spin rounded-full border-brand-500 border-t-transparent ${sizeClasses}`}
        aria-hidden
      />
      {label && <span className="ml-2 text-sm text-gray-600 dark:text-gray-400">{label}</span>}
      <span className="sr-only">{label || 'Loading…'}</span>
    </span>
  );
}

export default Spinner;
